import { UIRouterModule } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { CurrentUserServiceProvider } from "@webapp/people/providers/people.provider";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { SharedModalModule } from "@webapp/shared/modal/shared-modal.module";
import { UiAlertModule } from "@webapp/ui/alert/alert.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiLoadingIndicatorModule } from "@webapp/ui/loading-indicator/loading-indicator.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { UiTreeSelectModule } from "@webapp/ui/tree-select/tree-select.module";
import { ConfirmDeleteSessionComponent } from "./components/confirm-delete-session/confirm-delete-session.component";
import { SessionConflictComponent } from "./components/session-conflict/session-conflict.component";
import { SessionOverviewComponent } from "./components/session-overview/session-overview.component";
import { CountToDirective } from "./directives/count-to.directive";
import { ConfirmDeleteSessionService } from "./services/confirm-delete-session.service";
import { SessionSelectorComponent } from "./shared/components/session-selector/session-selector.component";

@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    FormsModule,
    ReactiveFormsModule,
    UiIconModule,
    UiTreeSelectModule,
    UiGridModule,
    UiFormModule,
    UiButtonModule,
    AssigneesModule,
    LocalizationModule,
    IndicatorModule,
    UiTooltipModule,
    UiInputModule,
    UiLoadingIndicatorModule,
    UiAlertModule,
    SharedModalModule,
  ],
  declarations: [SessionSelectorComponent, SessionOverviewComponent, SessionConflictComponent, CountToDirective, ConfirmDeleteSessionComponent],
  exports: [SessionSelectorComponent],
  providers: [CurrentUserServiceProvider, ConfirmDeleteSessionService],
})
export class SessionsModule {}
